import logo from '../logo.png';
import '../Styles/Radikle.css';

export function Radikle() {
    return (
        <a href="https://app.radikle.com" title="Take me to Radikle Home">
            <div className="brand-container" style={{marginBottom: '3em'}}>
                <label className="App-link">Radikle</label>
                <img className="logo-icon" src={logo} alt="icon" />
                <label className="App-link">AI</label>
            </div>
        </a>
        )
}